import React from "react";

// Si le pasan un color suelto ("#D9D9D9") lo convierte en un fondo; si ya es un degradado, lo deja igual
const aFondo = (valor) => (valor && valor.startsWith("#") ? `linear-gradient(${valor}, ${valor})` : valor);

// Ancho máximo del contenido de las páginas (el ancho del diseño de Figma)
export const ANCHO_MAXIMO = 1280;

// Contenedor de una sección. El contenido nunca pasa de 1280 px y queda centrado; en pantallas más anchas,
// a los costados se ve el color de fondo de la sección (izq y der: un color "#...", o un degradado vertical).
// Las líneas rojas (lineaArriba / lineaAbajo, por ejemplo "5px solid #D7192E") se dibujan acá, a todo el ancho.
export const FranjaFija = ({ izq, der, lineaArriba, lineaAbajo, children }) => (
  <div
    className="franja-fija"
    style={{
      backgroundImage: `${aFondo(izq)}, ${aFondo(der || izq)}`,
      borderTop: lineaArriba,
      borderBottom: lineaAbajo,
    }}
  >
    <div className="franja-fija-interior">{children}</div>
  </div>
);
